import {
    GET_FLAT_TRANSFER_PREVIEW,
    GET_FLAT_TRANSFER_PREVIEW_SUCCESS,
    GET_FLAT_TRANSFER_PREVIEW_FAILURE,
    EXECUTE_FLAT_TRANSFER,
    EXECUTE_FLAT_TRANSFER_SUCCESS,
    EXECUTE_FLAT_TRANSFER_FAILURE,
    GET_FLAT_TRANSFER_HISTORY,
    GET_FLAT_TRANSFER_HISTORY_SUCCESS,
    GET_FLAT_TRANSFER_HISTORY_FAILURE,
    GET_FLAT_TRANSFER_DETAIL,
    GET_FLAT_TRANSFER_DETAIL_SUCCESS,
    GET_FLAT_TRANSFER_DETAIL_FAILURE,
    REVERSE_FLAT_TRANSFER,
    REVERSE_FLAT_TRANSFER_SUCCESS,
    REVERSE_FLAT_TRANSFER_FAILURE,
    ADD_FLAT_TRANSFER_DOCUMENT,
    ADD_FLAT_TRANSFER_DOCUMENT_SUCCESS,
    ADD_FLAT_TRANSFER_DOCUMENT_FAILURE
} from '../../../actions/index.types';

const initialState = {
    preview: { loading: false, data: null, error: null },
    execute: { loading: false, posted: null, error: null },
    history: { loading: false, rows: [], pagination: null, error: null },
    detail: { loading: false, data: null, error: null },
    reverse: { loading: false, success: false, error: null },
    documents: { uploading: false, error: null, lastUploaded: null }
};

const FlatTransferReducer = (state = initialState, action) => {
    switch (action.type) {
        // Preview
        case GET_FLAT_TRANSFER_PREVIEW:
            return { ...state, preview: { loading: true, data: null, error: null } };
        case GET_FLAT_TRANSFER_PREVIEW_SUCCESS:
            return { ...state, preview: { loading: false, data: action.data, error: null } };
        case GET_FLAT_TRANSFER_PREVIEW_FAILURE:
            return { ...state, preview: { loading: false, data: null, error: action.data } };

        // Execute
        case EXECUTE_FLAT_TRANSFER:
            return { ...state, execute: { loading: true, posted: null, error: null } };
        case EXECUTE_FLAT_TRANSFER_SUCCESS:
            return { ...state, execute: { loading: false, posted: action.data, error: null } };
        case EXECUTE_FLAT_TRANSFER_FAILURE:
            return { ...state, execute: { loading: false, posted: null, error: action.data } };

        // History
        case GET_FLAT_TRANSFER_HISTORY:
            return { ...state, history: { ...state.history, loading: true, error: null } };
        case GET_FLAT_TRANSFER_HISTORY_SUCCESS:
            return {
                ...state,
                history: {
                    loading: false,
                    rows: action.data?.data || [],
                    pagination: action.data?.meta?.pagination || null,
                    error: null
                }
            };
        case GET_FLAT_TRANSFER_HISTORY_FAILURE:
            return { ...state, history: { ...state.history, loading: false, error: action.data } };

        // Detail
        case GET_FLAT_TRANSFER_DETAIL:
            return { ...state, detail: { loading: true, data: null, error: null } };
        case GET_FLAT_TRANSFER_DETAIL_SUCCESS:
            return { ...state, detail: { loading: false, data: action.data, error: null } };
        case GET_FLAT_TRANSFER_DETAIL_FAILURE:
            return { ...state, detail: { loading: false, data: null, error: action.data } };

        // Reverse
        case REVERSE_FLAT_TRANSFER:
            return { ...state, reverse: { loading: true, success: false, error: null } };
        case REVERSE_FLAT_TRANSFER_SUCCESS:
            return { ...state, reverse: { loading: false, success: true, error: null } };
        case REVERSE_FLAT_TRANSFER_FAILURE:
            return { ...state, reverse: { loading: false, success: false, error: action.data } };

        // Documents
        case ADD_FLAT_TRANSFER_DOCUMENT:
            return { ...state, documents: { uploading: true, error: null, lastUploaded: null } };
        case ADD_FLAT_TRANSFER_DOCUMENT_SUCCESS:
            return { ...state, documents: { uploading: false, error: null, lastUploaded: action.data } };
        case ADD_FLAT_TRANSFER_DOCUMENT_FAILURE:
            return { ...state, documents: { uploading: false, error: action.data, lastUploaded: null } };

        default:
            return state;
    }
};

export default FlatTransferReducer;
